var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","justify-content":"center","align-items":"center","height":"100%"}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("欢迎使用 物联网平台")])])
}]

export { render, staticRenderFns }